import {
  withCompInfo,
  withCompPreviewInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData,
  StripColumnsContainerCss,
} from '../StripColumnsContainer.types';
import { withSiteDirection } from '@wix/editor-elements-common-utils';

export const props = withCompInfo<
  StripColumnsContainerCarmiData,
  StripColumnsContainerDefinition,
  StripColumnsContainerCarmiData
>()([], (_, carmiData) => {
  return carmiData;
});

export const css = withCompPreviewInfo<
  StripColumnsContainerCss,
  StripColumnsContainerDefinition,
  StripColumnsContainerCss
>()(
  ['compProps', 'compData', 'isMobileView'],
  ({ compProps, compData, isMobileView }, carmiData) => {
    // temporary fix to https://jira.wixpress.com/browse/TB-1838 issue in mobile that caused by chromium bug (https://bugs.chromium.org/p/chromium/issues/detail?id=1168537#c1) - should remove when fixed
    const { columnsMargin, rowMargin, horizontalPaddingOnMobile } = compProps;
    const direction = compData?.direction ?? 'ltr';

    const mobileStyles = isMobileView
      ? {
          ...(columnsMargin === 0 && { '--margin': '-1px' }),
          ...(rowMargin === 0
            ? { '--padding-y': '-1px' }
            : { '--padding-y': `${rowMargin}px` }),
          ...(horizontalPaddingOnMobile && {
            '--padding-x': `${horizontalPaddingOnMobile}px`,
          }),
        }
      : {};

    return {
      ...carmiData,
      '--firstChildMarginTop': columnsMargin === 0 ? '-1px' : undefined,
      '--lastChildMarginBottom': columnsMargin === 0 ? '-1px' : undefined,
      '--direction': withSiteDirection(direction),
      ...mobileStyles,
    };
  },
);

export const uiType = withCompInfo<any, any>()(['skin'], ({ skin }) => {
  if (skin === 'DesignedStrip') {
    return 'DesignedStrip';
  }
  return 'Default';
});

export default createComponentMapperModel({
  props,
  css,
  uiType,
});
